/* パスワード設定 */
import React, { useState, useEffect } from 'react';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import axios from '../axios';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import 'url-search-params-polyfill';
import LoadingModal from '../molecules/LoadingModal';
import { isBrowserIe } from '../BrowserJudgment';
import { createRoot } from 'react-dom/client';

const PasswordChange: React.FC = () => {
  // 処理結果通知ダイアログ
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const successDialogMessage = 'パスワードを登録しました。';
  const failDialogMessage = 'パスワードの登録が失敗しました。';

  // メールアドレス
  const [email, setemail] = useState('');
  // パスワード
  const [password, setPassword] = useState('');
  // パスワード(確認)
  const [password_confirmation, setPasswordConfirmation] = useState('');
  const [password_change_message, setRegisterPasswordResult] = useState('');
  const [dialog_message, setDialogMessage] = useState('');
  // 申込人か否か
  const [status_code, setStatusCode] = useState(0);
  // API通信中フラグ
  const [is_connecting, setIsConnecting] = useState(false);

  //ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
    //emailアドレスを取得
    const getemail = async () => {
      const response = await axios.get(`mypage/register/password/getemail`);
      setemail(response.data['email']);
    };
    getemail();
  }, []);

  // 案件一覧画面へ遷移
  const redirectToReception = async () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`;
  };

  // 次へボタンのクリックイベントを定義
  const handlePasswordChange = () => {
    //入力したパスワード情報をセット
    const password_info = {
      password: password,
      password_confirmation: password_confirmation,
    };

    const passwordRegister = async () => {
      try {
        if (is_connecting) {
          return;
        }
        //ローディング画面表示
        setIsLoading(true);
        setIsConnecting(true);

        const url = `/mypage/register/password`;
        const response = await axios.post(url, password_info);
        setDialogMessage(successDialogMessage);
        setStatusCode(response.status);

        // ダイアログ表示
        handleShow();
        setIsConnecting(false);
      } catch (error) {
        setRegisterPasswordResult(error.response.data.message);
        setStatusCode(error.response.status);
        setDialogMessage(failDialogMessage);
        setIsConnecting(false);
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };
    // パスワード変更処理
    passwordRegister();
  };

  // 要素のセンタリングのクラス名を動的に生成する（IEは生成しない、それ以外は生成する）
  const justify_content_center = isBrowserIe() ? '' : 'justify-content-center';

  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="パスワード設定"
        content={
          <>
            <div>
              <Text
                id="email"
                label="メールアドレス"
                type="email"
                value={email}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setemail(event.target.value)
                }
                disabled={true}
                maxlength={200}
              />
            </div>
            <div className="mt-3"></div>
            <Annotation text="マイページ開設用パスワードを入力してください。" />
            <div className="mt-3"></div>
            <div>
              <Text
                id="password"
                label="パスワード"
                type="password"
                value={password}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setPassword(event.target.value)
                }
                disabled={false}
                maxlength={200}
              />
            </div>
            <div className="mt-3">
              <Text
                id="password-confirm"
                label="パスワード（確認）"
                type="password"
                value={password_confirmation}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setPasswordConfirmation(event.target.value)
                }
                disabled={false}
                maxlength={200}
              />
            </div>
            <div className="mt-3"></div>
            <Annotation text="※パスワードは、英字・数字を含む8文字以上で設定してください。" />
            <div className="mt-3"></div>
            <Row className="d-flex align-items-center justify-content-center">
              <Col></Col>
              {password_change_message !== undefined &&
                // パスワード変更失敗メッセージあり
                status_code !== 201 && (
                  // 失敗
                  <Col md={9} className="alert-danger alert-danger-custom">
                    {password_change_message}
                  </Col>
                )}
            </Row>
          </>
        }
      />
      <div className="mt-5" />
      <CenterButton label="次へ" handleClick={handlePasswordChange} />
      <div className="mt-4" />
      {/* モーダル */}
      <Modal
        className={`d-flex align-items-center ${justify_content_center}`}
        show={show}
        onHide={
          password_change_message !== undefined && status_code == 201
            ? redirectToReception
            : handleClose
        }
        animation={false}
      >
        <Modal.Header>
          <Modal.Title className="dialog-title"></Modal.Title>
        </Modal.Header>
        <Modal.Body className="dialog-body">{dialog_message}</Modal.Body>
        <Modal.Footer>
          {password_change_message !== undefined &&
            // パスワード変更結果メッセージあり
            (status_code == 201 ? (
              // 成功
              <Button variant="primary" onClick={redirectToReception}>
                OK
              </Button>
            ) : (
              // 失敗
              <Button variant="secondary" onClick={handleClose}>
                OK
              </Button>
            ))}
        </Modal.Footer>
      </Modal>
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </>
  );
};

const container = document.getElementById('register-password');
if (container) {
  const root = createRoot(container);
  root.render(<PasswordChange />);
}
